import { id, root } from './vod-plans';

export const vodPlans = {
  ...root,
  id,
};
